var _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8434 15.9995C28.8434 23.0803 22.8319 28.8435 15.9995 28.8435C9.16708 28.8435 3.15552 23.0803 3.15552 15.9995C3.15552 8.90598 8.90595 3.15555 15.9995 3.15555C23.093 3.15555 28.8434 8.90598 28.8434 15.9995Z",
    stroke: "#0A0A0A",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.9991,
    cy: 10.8089,
    r: 3.32624,
    stroke: "#0A0A0A",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7872 20.7606C22.7872 21.2529 22.362 21.9679 21.0591 22.6193C19.816 23.2409 18.0287 23.6542 15.9999 23.6542C13.9711 23.6542 12.1838 23.2409 10.9407 22.6193C9.63784 21.9679 9.21271 21.2529 9.21271 20.7606C9.21271 20.2847 9.26521 19.9215 9.38689 19.6282C9.49973 19.3562 9.69298 19.093 10.0733 18.8467C10.9008 18.3107 12.5908 17.8669 15.9999 17.8669C19.409 17.8669 21.0991 18.3107 21.9266 18.8467C22.3069 19.093 22.5001 19.3562 22.613 19.6282C22.7347 19.9215 22.7872 20.2847 22.7872 20.7606Z",
    stroke: "#0A0A0A",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.22530da4fc8409d2a19d341cc6cabb1c.svg";
export { ForwardRef as ReactComponent };